const initialState = {
    wellbeing: null,
    learning: null,
    mindset: null,
    resilience: null,
    snackbarMenu: {
        open: false,
        transition: null,
        title: '',
        recommendation: 0,
        leveltext: '',
        levelpercent: 0,
        traitid: '',
    },
    weather: '',
    isHover: false,
    dailyChestClaim: {
        ableToClaim: true,
        foodCount: 0,
        coins: 0,
    },
    monster: {
        cluster: '',
        lvl: 0
    },
    monsterMenu: {
        open: false,
        cluster: '',
        monsterLvl: 0,
        moodMeter: 0,
        feedCount: 0,
        isMissing: false,
        messages: [],
        isEating: false,
        monsterSize: { x: 0.3, y: 0.3 },
    },
};

const homeReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_WELLBEING':
            return { ...state, wellbeing: action.wellbeing };
        case 'SET_LEARNING':
            return { ...state, learning: action.learning };
        case 'SET_MINDSET':
            return { ...state, mindset: action.mindset };
        case 'SET_RESILIENCE':
            return { ...state, resilience: action.resilience };

        case 'SET_SNACKBAR_MENU':
            return { ...state, snackbarMenu: action.snackbarMenu };
        case 'SET_WEATHER':
            return { ...state, weather: action.weather };
        case 'SET_ISHOVER':
            return { ...state, isHover: action.isHover };
        case 'SET_DAILYCHESTCLAIM':
            return { ...state, dailyChestClaim: action.dailyChestClaim };
        case 'SET_MONSTER':
            return { ...state, monster: action.monster };
        case 'SET_MONSTER_MENU':
            return { ...state, monsterMenu: action.monsterMenu };
        default:
            return state;
    }
}

export { homeReducer as default }